import { useCallback, useRef, useState } from 'react';

const useSubmitLock = () => {
    const inFlightRef = useRef(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const runWithLock = useCallback(async (callback) => {
        if (inFlightRef.current) {
            return undefined;
        }

        inFlightRef.current = true;
        setIsSubmitting(true);

        try {
            return await callback();
        } finally {
            inFlightRef.current = false;
            setIsSubmitting(false);
        }
    }, []);

    return {
        isSubmitting,
        runWithLock,
    };
};

export default useSubmitLock;